<template>
	<div class="waiting-container flex-parent">
		<div class="flex-center container main border-l center">
			<h4 class="room-code">Game {{ roomCode }}</h4>
			<h1>Waiting for other players...</h1>
			<ul class="joined-players-list mt-24">
				<template v-for="(player, index) in players" :key="index">
					<li
						class="player"
						:class="player === null ? 'waiting' : 'joined-player'"
					>
						<template v-if="player === null">
							{{ "Waiting for player..." }}
						</template>
						<template v-else>
							{{ player.name }}
							<span v-if="player.pos === me" class="me">me</span>
						</template>
					</li>
				</template>
			</ul>
			<secondary-button
				class="mt-16 mb-16 full-width"
				v-clipboard="copyGameLink"
				@click="addError('Copied link to game')"
				>Copy invite link</secondary-button
			>
			<a @click="this.$router.push('/')" class="leave">Leave game</a>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SecondaryButton from "../components/ui/SecondaryButton";
export default {
	components: {
		SecondaryButton,
	},
	computed: {
		...mapGetters(["roomCode", "players", "me", "mocking"]),
		copyGameLink() {
			return location.origin + "/invite/" + this.roomCode;
		},
	},
	methods: {
		...mapActions(["tryLeaveGame", "addError", "playStartGame"]),
		handleLeave() {
			this.tryLeaveGame();
			this.$router.push("/login");
		},
		handleStart() {
			this.playStartGame();
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/main.scss";

.waiting-container {
	height: 100%;
}
h4.room-code {
	color: $blue-lightest;
	font-size: 14px;
	text-transform: uppercase;
}

.joined-players-list {
	list-style: none;
	.player {
		font-size: 16px;
		margin: 12px 0;
		&.joined-player {
			font-weight: bold;
		}
		&.waiting {
			color: $blue-lightest;
		}
	}
}

.leave {
	display: block;
	color: $blue-lightest;
	width: 100%;
	font-size: 13px;
	text-align: center;
	cursor: pointer;
	transition-duration: $trd-s;
	&:hover {
		color: lighten($blue-lightest, 10%);
	}
}
</style>
